import { render } from "./QRBakai.vue?vue&type=template&id=5d82607c"
import script from "./QRBakai.vue?vue&type=script&lang=js"
export * from "./QRBakai.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__